export default { 
  name: "galleries",
  methods: {
    loadGalleries: function (type) {
      this.page = this.$route.params.page;
      let url = `${process.env.VUE_APP_DXA_ENDPOINT}/thg/galleries`;
      if (type === "pages") {
        url += `?pagesize=8&page=${this.page}`;
      }
      axios({ method: "GET", "url": url }).then(result => {
        let galleries = result.data.items;
        // if (Array.isArray(galleries)) {
        //   for (let i = 0; i < result.data.items.length; i++) {
        //     if (result.data.items[i].galleryKey === "galleries") {
        //       result.data.items.splice(i, 1);
        //       break;
        //     }
        //   }
        // } else {
        //   for (let gallery in galleries) {
        //     if (galleries[gallery].galleryKey === "galleries") {
        //       delete galleries[gallery];
        //       break;
        //     }
        //   }
        // }
        let array = [];
        for (let gallery in galleries) {
          array.push(galleries[gallery]);
        }
        if (type === "all" || type === "pages") {
          this.galleries = array;
          this.pageInfo = result.data.page;
          this.pages = result.data.links;
          this.setResultsExist();
          this.setDisplayPageNavigation();
        } else if (type === "list") {
          this.allGalleries = galleries;
        }
        this.loaded = true;
      }, error => {
        console.error(error);
      });
    },
  }
}